import { render, staticRenderFns } from "./WaCalback.vue?vue&type=template&id=76281282&scoped=true&"
import script from "./WaCalback.vue?vue&type=script&lang=js&"
export * from "./WaCalback.vue?vue&type=script&lang=js&"
import style0 from "./WaCalback.vue?vue&type=style&index=0&id=76281282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76281282",
  null
  
)

export default component.exports